import dayjs from 'dayjs'

export const formatDate = (str, format = 'DD/MM/YYYY') => {
  if (!str) return null
  return dayjs(str).format(format)
}
